<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 style="margin-top:25px;">Frequently Asked Questions</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ul>
          <li>
            <span class="font-weight-bold">What is the Minnesota NAR system?</span><br/>
            The NAR system lists nurse aides who have met Minnesota training and/or testing standards to work in nursing homes and certified boarding care homes.
            The registry also has information about nurse aides who have substantiated findings of abuse, neglect, and theft. Nurse aides, employers, and others
            can check the registry which is secure and considered primary source for verification of a Minnesota Nurse Aide certificate.
          </li>
          <li>
            <span class="font-weight-bold">Is the NAR system used for reporting Minnesota employment?</span><br/>
            Yes. Nurse aides can report on their renewal application their last employment date. The employment date should only report for nursing or nursing-related
            services. Please note, the MN NAR system is not an employment hub. MDH cannot provide employment history and dates to potential employers or staffing agencies.
            Instead, the nurse aide can print their own employment history from their Dashboard and provide that information to the employer or staffing agency.
          </li>
          <li>
            <span class="font-weight-bold">What can I do once I register my account in the NAR system?</span><br/>
            Nurse aides can update their contact information, view and update their employer information, view testing history, renew their certificate, and print their certificate.
          </li>
          <li>
            <span class="font-weight-bold">Can I email my application and documents to the Minnesota Department of Health?</span><br/>
            No. All documents in PDF format must be uploaded into the NAR system.
          </li>
          <li>
            <span class="font-weight-bold">Is there a walk-up window or walk-in hours?</span><br/>
            No. The Minnesota registry does not have a walk-up window or walk-in hours.
          </li>
          <li>
            <span class="font-weight-bold">Do I need to attach a job description?</span><br/>
            A job description is needed for employment outside of nursing home, certified boarding care home, assisted living, Medicare certified home health agency or hospice.
          </li>
          <li>
            <span class="font-weight-bold">How will I be notified if my application is not accepted?</span><br/>
            You will receive a message via text or email using the notification option you selected when you registered.
            You need to log into your account and review the message sent.
          </li>
          <li>
            <span class="font-weight-bold">How do I know if you have received my email?</span><br/>
            If you received our automatic response, your email has been received by one of the MDH Credentialer.
            Emails are responded back in the order they are received.
          </li>
          <li>
            <span class="font-weight-bold">What is the processing time from when I submitted my application?</span><br/>
            Applications are processed by MDH in the order they are received. The processing time may take up to 45 business days and is dependent on the
            current workload and whether an application has the proper and complete supporting documents.
          </li>
          <li>
            <span class="font-weight-bold">If I resubmitted a returned application, does my application go back into the queue at the end of the waiting line?</span><br/>
            No. A NAR Credentialer will see resubmitted applications and process in the order they are received.
          </li>
          <li>
            <span class="font-weight-bold">What do I need to do if my certificate has already expired?</span><br/>
            Make sure you have an account on the Nurse Aide Registry system. You must apply for a renewal with the required documents.
            You can email health.fpc-nar@state.mn.us or call the main office line at (651) 201-4200 to speak to one of the NAR Credentialer if you have any questions.
          </li>
          <li>
            <span class="font-weight-bold">Can I use clinic employment to renew my Minnesota registry status?</span><br/>
            No. Clinic employment cannot be used to renew your Minnesota registry status. Other unacceptable employment types include outpatient surgical centers,
            ambulatory surgical centers, urgency centers, urgent care, dental clinics, work as a phlebotomist, EMT, or work paid through a Fiscal Intermediary.
          </li>
          <li>
            <span class="font-weight-bold">Can I use a volunteer position to renew my Minnesota registry status?</span><br/>
            No. You must show 8 regular compensated employment hours to renew your Minnesota registry status. Hours must be earned during the previous 24 months.
          </li>
          <li>
            <span class="font-weight-bold">Can I use employment as an independent contractor to renew my Minnesota registry status?</span><br/>
            No.
          </li>
          <li>
            <span class="font-weight-bold">Can I use private duty employment to renew my registry status?</span><br/>
            No, but there are certain instances where private duty employment would be acceptable. Please contact one of the NAR Credentialer.
          </li>
          <li>
            <span class="font-weight-bold">What documents need to be attached to my renewal application?</span><br/>
            A paystub showing at least 8 hours of regular pay for employment performed on or before your expiration date.
            Orientation or training hours are excluded from the 8 regular hours.
          </li>
          <li>
            <span class="font-weight-bold">Can I update personal data in the Nurse Aide Registry system?</span><br/>
            Yes. You can update your personal data. The necessary legal documents must be included with requests for name changes and Social Security Number corrections.
            After reviewing the uploaded documents, a NAR Credentialer will process the request. Any rejections will be communicated back to you.
          </li>
          <li>
            <span class="font-weight-bold">How do I know if my registry status has been renewed?</span><br/>
            Once your application is processed, you will receive a message by text or email using the notification option you selected when you registered.
            Your certificate is printable through the Nurse Aide Registry system.
          </li>
          <li>
            <span class="font-weight-bold">How do I get my endorsement or verification form completed?</span><br/>
            MDH no longer processes endorsement or verification forms for other state nurse aide registries or licensing boards.
            Please direct the requester to the NAR system (a primary source verification) to complete the form.
            If there are additional items listed on the form that are not available on the system, you may email the verification form to MDH to complete.
            The form must be a PDF, allow MDH to sign digitally, and provide an email address where the form should be sent to.
            Once completed, MDH will email the completed form to the state nurse aide registry or licensing board and carbon copy the nurse aide.
          </li>
          <li>
            <span class="font-weight-bold">Do I need to complete a training program before I can take the knowledge test and skills test?</span><br/>
            No. Any person can attempt to take the knowledge test and the skills test without taking a training program.
          </li>
          <li>
            <span class="font-weight-bold">How will nursing homes and certified boarding care homes complete the semi-annuals for staff reporting in the NAR system?</span><br/>
            Nursing homes and certified boarding care homes will be able to create an account and update their nurse aides in real time.
            This means the facility can submit daily, weekly, monthly, or quarterly staff reporting.
            It is recommended facilities stay on top of their staff reporting to prevent a lapse in their nurse aides’ certificate.
            If there’s a lapse, the nurse aide will need to submit a renewal application with supporting documents in the system.
          </li>
          <li>
            <span class="font-weight-bold">What employment of nurse aides should Facilities/Agencies report?</span><br/>
            Facilities can extend the expiration date of a nurse aide's certificate based on Last Worked Date.
            Please note that only nurse aides who meet the requirements under 42 CFR 483.156(c) (opens in new tab) and 42 CFR 483.35 (d) (opens in new tab) can renew their certificate.
            Non-related nursing services do not meet the requirement to renew.
          </li>
          <li>
            <span class="font-weight-bold">For Facilities: Who should create and register an account within the Nurse Aide Registry system?</span><br/>
            At this time only nursing homes and certified boarding care homes can create and register an account.
            The Administrator or Authorized Agent (AA) listed on file, with MDH Federal Licensing, Certification and Registration (LCR) section, can only create and register the account.
            From there, the Administrator/AA can add up to three (3) additional users to help manage and submit staff reports.
          </li>
          <li>
            <span class="font-weight-bold">For Facilities: Which email will receive the Registration key?</span><br/>
            MDH will send the Registration key to the email on file for that facility. Please note, we cannot change or update the email.
            If there is a change in the Administrator/AA, have the new person must contact the Federal LCR team at Health.HRD-FEDLCR@state.mn.us to request the email be updated/changed.
            The email in the NAR system will automatically be updated once the Federal LCR team approves the change.
            At that point, the new Administrator/AA can request to resend the Registration key.
          </li>
          <li>
            <span class="font-weight-bold">Which email should I use as the administrator to set up my account?</span><br/>
            A personal work email can be used and not a personal email.
          </li>
          <li>
            <span class="font-weight-bold">How will Facilities/Agencies (other than Nursing Homes and Certified Boarding Care Homes) report their nurse aides’ employment to the system?</span><br/>
            Previously, providers such as assisted living facilities, Medicare certified home health agencies and hospices would email or mail their nurse aides’ employment along with required documents to the Nurse Aide Registry program.
            In order to be placed on the registry, facilities must now inform their nurse aides about the NAR system.
            The nurse aide will need to create an account and submit the required documents.
            The request will be processed by a NAR Credentialer, who will notify the nurse aide of any rejections or missing items.
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="mt-3">
          <router-link :to="{name: 'home'}">
            <b-button id="btnHome" variant="primary">Return Home</b-button>
          </router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'pay-stubs',

  created() {
     document.title = "Providing Pay Stubs FAQ - NAR"
  }
}
</script>

<style>
 li{
   margin-top:1rem;
 }
</style>